import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import './InfoTabs.css';

export default function InfoTabs({ tabbedComponents, defaultActiveKey = null, className = 'mb-3' }) {
	
	return (
		<Tabs
			defaultActiveKey={defaultActiveKey || (tabbedComponents.length > 0 ? tabbedComponents[0].eventKey : null)}
			className={className}
		>
			{tabbedComponents.map((tab) => (
				<Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
					{tab.component}
				</Tab>
			))}
		</Tabs>
	);
}